module.exports = __webpack_public_path__ + "static/media/hiw6.1866899c.svg";